import { useEffect, useRef } from "react";
import { useInView, useMotionValue, useSpring } from "framer-motion";

export default function CountUp({
    to,
    from = 0,
    direction = "up",
    delay = 0.5,
    duration = 2, // Duration of the animation in seconds
    onStart,
    onEnd,
}) {
    const ref = useRef(null);
    const motionValue = useMotionValue(direction === "down" ? to : from);

    // Use a spring for smooth animation
    const springValue = useSpring(motionValue, {
        damping: 30,
        stiffness: 100,
    });

    const isInView = useInView(ref, { once: true, margin: "0px" });

    useEffect(() => {
        if (isInView) {
            setTimeout(() => {
                motionValue.set(direction === "down" ? from : to);
                if (onStart) onStart();
            }, delay * 1000);
        }
    }, [isInView, delay, to, from, direction, motionValue, onStart]);

    useEffect(() => {
        return springValue.on("change", (latest) => {
            if (ref.current) {
                ref.current.textContent = Intl.NumberFormat("en-US").format(
                    latest.toFixed(0)
                );
            }
        });
    }, [springValue]);

    return <span ref={ref} className="count-up" />;
}
